import {EuiButton, EuiDatePickerRange, EuiFlexItem } from "@elastic/eui";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useMemo, useState }  from "react";
import moment from "moment";
import SelectorFecha from "../../../../shared/components/Combos/Fecha";
import ComboEstadosContainer from "../Selectores/Estados/container";
import { PropsFilterMenu } from "./interface";
import { CreateFechaMoment, ToSQL } from "../../../../shared/utils/fecha";
import ComboSociedadesContainer from "../Combos/Sociedades/container";
import './styles.css'

//import { optionTodas } from "../Combos/Sociedades/functions";

export const FiltrosMenu =(props: PropsFilterMenu) => {
  //const {filtroInicial, onChangeFilter, dateInit, selectorEstado, selectorSociedades, otherFilters} = props;

  const {filtroInicial, onChangeFilter, onFilterData, dateInit, selectorEstado, selectorSociedades, otherFilters} = props;

  const _init = dateInit!==undefined ? 
  (moment().week()>1 ? moment().startOf('month') : (moment().set('month', moment().month()-1)).startOf('month'))
  : moment().startOf('year')

  const fIni = otherFilters ? CreateFechaMoment(otherFilters.fechaDesde): _init;
  const fFin = otherFilters ? CreateFechaMoment(otherFilters.fechaHasta): moment().endOf('month');

  let [fechaIni, setFechaIni] = useState<any>(fIni);
  let [fechaFin, setFechaFin] = useState<any>(fFin);
  let [codEstado, setEstado] = useState(otherFilters===undefined?1:5);
  let [sociedad, setSociedad] = useState<any>(undefined);
  let [disabledBtn, setDisabledBtn] = useState(true)

  useEffect(() => {onFilter();}, []);

  const onChangeFechaIni = (value:any)=>{
    setFechaIni(value)
  }

  const onChangeFechaFin = (value:any)=>{
    setFechaFin(value)
  }

  const onChangeEstado = (value:any)=>{
    setEstado(value)
  }

  const onChangeSociedad = (value:any)=>{
    console.log('onchange sociedad')
    setSociedad(value.length>0 ? value : undefined)
  }

  useMemo(()=>setDisabledBtn(false),[fechaIni,fechaFin,codEstado,sociedad])

  const onFilter = () => {
    // if(onFilterData!==undefined)
    // {
      let data = {
        fechaDesde: ToSQL(fechaIni,"-"),
        fechaHasta: ToSQL(fechaFin,"-"),
        estado: (codEstado),
        idSociedad: (sociedad!==undefined && sociedad.length>0) ? sociedad[0].value : undefined,
        filterDrillDown: otherFilters === undefined ? '' : otherFilters.option
      }
      setDisabledBtn(true)
      onChangeFilter && onChangeFilter(data)
    // }else{
    // setDisabledBtn(true)
    // onFilterData && onFilterData()
    //}
  }

  const getSelectorEstado = useCallback(() =>{
    return (selectorEstado!==undefined && selectorEstado===true) ? 
    <EuiFlexItem><ComboEstadosContainer fullWidth valueOfSelected={codEstado} onChange={onChangeEstado} isInvalid={codEstado===undefined}/></EuiFlexItem> 
    : null
  },[selectorEstado, codEstado, onChangeEstado])


  const getSelectorSociedades = useCallback(() => {
  if (!selectorSociedades) return null;

  return (
    <EuiFlexItem>
      <ComboSociedadesContainer
        fullWidth
        optionAll
        firstDefault
        selectedOptions={sociedad}
        onChange={(value: any) => onChangeSociedad(value)}
      />
    </EuiFlexItem>
  );
}, [selectorSociedades, sociedad, onChangeSociedad]);

  // const getSelectorSociedades =  useCallback(() =>{
  //   return (selectorSociedades!==undefined && selectorSociedades===true) ? 
  //   <EuiFlexItem><ComboSociedadesContainer fullWidth optionAll firstDefault selectedOptions={undefined} 
  //   onChange={(value:any) =>{onChangeSociedad(value)}}/></EuiFlexItem> 
  //   : null
  // },[selectorSociedades, sociedad, onChangeSociedad])
  
  console.log('render filtros')
return (
<>
<EuiFlexItem>
  <EuiDatePickerRange
  fullWidth
  startDateControl={
    <SelectorFecha
      selected={fechaIni}
      onChange={onChangeFechaIni}
      isInvalid={fechaIni > fechaFin}
      aria-label="Inicio"
    />
  }
  endDateControl={
    <SelectorFecha
      selected={fechaFin}
      onChange={onChangeFechaFin}
      isInvalid={fechaIni > fechaFin}
      aria-label="Fin"
    />
  }
/>
</EuiFlexItem>
  {getSelectorEstado()}
  {getSelectorSociedades()}
<EuiFlexItem grow={false} >
  <EuiButton
    fill
    className="btnRefresh"
    isDisabled={disabledBtn}
    onClick={onFilter}
    iconType="refresh"
    aria-label="Filtrar"
    iconSide="left"
    size="s"
  >{'Refrescar'}</EuiButton>
</EuiFlexItem> 
</>
)
}

export default FiltrosMenu;